import { useState } from 'react';
import { AlertData } from '@/Shared';


export interface AlertHook {
    alertData?: AlertData | null,
    openAlert: (data: AlertData, onClose? : () => void) => void,
    closeAlert: () => void,
}
export function useAlert(): AlertHook {
    const [alertData, setAlertData] = useState<AlertData | null>();
    const [onClose, setOnClose] = useState<() => void>();

    const openAlert = (data: AlertData, onClose? : () => void) => {
        setAlertData(data);
        setOnClose(onClose);
    }

    const closeAlert = () => {
        setAlertData(null);
        onClose?.();
    }

    return {
        alertData,
        openAlert,
        closeAlert,
    };
}
